import { IconButton, MenuItem, Select } from "@mui/material";
import { EVENT_TYPE, STATUS } from "../types/types";
import { dbUpdateEvent, dbDeleteEvent } from "../api/api";
import ClearIcon from "@mui/icons-material/Clear";

interface Props {
    options: any[];
    eventData: any;
    matchData: any;
    justifyContent: string;
    isAdmin: boolean;
    tournamentId: string;
    editable?: boolean;
}

const cardStyles = {
    width: '14px',
    height: '22px',
    borderRadius: '3px',
    display: 'inline-block',
};

function EventRow(props: Props) {
    const { options, eventData, matchData, justifyContent, isAdmin, tournamentId, editable } = props;

    const updateEvent = (playerId: string | "") => {
        dbUpdateEvent({
            id: eventData.id,
            match: matchData.id,
            team: eventData.team.id,
            tournament: tournamentId,
            player: playerId || null,
            eventNumber: eventData.eventNumber,
            eventType: eventData.eventType,
        });
    };

    const deleteEvent = () => {
        dbDeleteEvent(eventData.id);
    };

    const getEventIcon = () => {
        if (eventData.eventType === EVENT_TYPE.GOAL) {
            return <span style={{ fontSize: '20px' }}>⚽</span>;
        } else if (eventData.eventType === EVENT_TYPE.YELLOW_CARD) {
            return <div style={{ ...cardStyles, backgroundColor: '#FFD700' }} />;
        } else if (eventData.eventType === EVENT_TYPE.RED_CARD) {
            return <div style={{ ...cardStyles, backgroundColor: '#DC143C' }} />;
        }
        return null;
    };

    return (
        <div style={{ display: "flex", width: "100%", justifyContent: justifyContent, alignItems: "center" }}>
            {isAdmin && (matchData.status === STATUS.PLAYING || editable) ? (
                <>
                    {getEventIcon()}
                    <Select
                        sx={{
                            height: "30px",
                            width: "40%",
                            color: "white",
                            marginLeft: "8px",
                            "& .MuiSvgIcon-root": { color: "white" },
                        }}
                        value={eventData.player?.id || ""}
                        onChange={(e) => updateEvent(e.target.value as string)}
                        displayEmpty
                        renderValue={(selected) => {
                            if (!selected) return "Ukendt spiller";
                            const player = options.find((p) => p.id === selected);
                            return player ? player.name : "Ukendt spiller";
                        }}
                        MenuProps={{
                            PaperProps: {
                                sx: {
                                    bgcolor: "black",
                                    color: "white",
                                },
                            },
                        }}
                    >
                        <MenuItem value="">
                            <em>Ukendt spiller</em>
                        </MenuItem>
                        {options.map((player) => (
                            <MenuItem key={player.id} value={player.id}>
                                {player.number} {player.name}
                            </MenuItem>
                        ))}
                    </Select>
                    <IconButton
                        aria-label="delete"
                        color="primary"
                        onClick={deleteEvent}
                    >
                        <ClearIcon sx={{ color: "#3c3c3c" }} fontSize="small" />
                    </IconButton>
                </>
            ) : (
                <div
                    style={{
                        display: "flex",
                        justifyContent: justifyContent,
                        width: "100%",
                        color: "white",
                        padding: "0px 5px",
                        alignItems: "center",
                        gap: "8px",
                    }}
                >
                    {getEventIcon()}
                    <p>{eventData.player ? eventData.player.name : "Ukendt spiller"}</p>
                </div>
            )}
        </div>
    );
}

export default EventRow;
